import { createSelector } from 'reselect';
import { getScopes } from './getScopes';
const HELP_DESK_ACCESS = 'help-desk-access';
export const hasHelpDeskAccess = createSelector([getScopes], scopes => scopes.includes(HELP_DESK_ACCESS));